import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { sendAddToCartEvent } from "@insite/client-framework/OdpEvents/AddToCartEvent";
import { AddProductApiParameter, addProductWithResult } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, LoadCart, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { addProductWithResultReelId } from "@tKgpco/Services/ReelIdCartService";

export interface AddProductApiParameterCustom extends AddProductApiParameter {
    properties: any;
}

type Parameter = {
    onError?: (error: string) => void;
} & AddProductApiParameterCustom &
    HasOnSuccess<CartLineModel>;

type Props = {
    apiParameter: AddProductApiParameterCustom;
    apiResult: CartLineModel;
};

type HandlerType = Handler<Parameter, Props>;

export const SendDataToApiCustom: HandlerType = async props => {
    const result = props.parameter?.properties?.reelId
        ? await addProductWithResultReelId(props.apiParameter)
        : await addProductWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result as unknown as CartLineModel;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const LoadCartCustom: HandlerType = async props => {
    const awaitableLoadCurrentCart = makeHandlerChainAwaitable(loadCurrentCart);
    await awaitableLoadCurrentCart({ getPromotions: true, getCartLines: true })(props.dispatch, props.getState);
};

replaceInChain(chain, SendDataToApi, SendDataToApiCustom);
replaceInChain(chain, LoadCart, LoadCartCustom);
